// eslint-disable-next-line react/prop-types
import React, { Suspense } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserProvider } from './context/UserContext';
import Router from './router/router';
import ErrorBoundary from './Component/ErrorBoundary/ErrorBoundary';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const App = () => {
  // Must be chosen at render time — isNativeApp is injected before scripts run, but
  // a module-level constant can still pick BrowserRouter too early on some WebViews.
  const AppRouter =
    typeof window !== 'undefined' &&
    window.isNativeApp &&
    window.ReactNativeWebView
      ? HashRouter
      : BrowserRouter;

  return (
    <ErrorBoundary>
      <UserProvider>
        <AppRouter>
          <Suspense fallback={loading}>
            <Router />
          </Suspense>
          <ToastContainer />
        </AppRouter>
      </UserProvider>
    </ErrorBoundary>
  );
};

export default App;
